import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _TaxHold } from '../../../../core/services/dataBean/EntityCatalog';
import Select from 'react-select';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';

interface Props {

    idSelector: number;
    onChange: any;
    label?: string;
    renderType?: "ID" | "Table";
    
}

export const TaxHoldeditor = ({ idSelector, onChange, label ,renderType = "ID"}: Props) => {

    const TaxHold = useDataBean(_TaxHold)
    const [lista, setLista] = useState<any>([])
    const [bean, setBean] = useState<any>({})
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const modalTable = useModal("Impuesto",MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        const selector = Number(idSelector);

        if (idSelector !== null && idSelector !== undefined && selector >= 0 && lista.length > 0) {
            const found = lista.find((item: any) => item.DataBeanProperties.IDTaxHold === selector);
            if (found) {
                const taxHold = found.DataBeanProperties;
                setSelectedOption({
                    value: taxHold.IDTaxHold,
                    label: getTaxHoldLabel(taxHold),
                    item: found
                });
                setBean(taxHold);
            } else {
                setSelectedOption(null);
                setBean({});
            }
        } else {
            setSelectedOption(null);
            setBean({});
        }
    }, [idSelector, lista])

    const handleChange = (option: any) => {
        setSelectedOption(option);
        setBean(option ? option.item.DataBeanProperties : {});
        onChange(option ? option.value : null);
    };

    const handleRowSelect = (row: any) => {
        setBean(row);
        setSelectedOption({
            value: row.IDTaxHold,
            label: getTaxHoldLabel(row),
            item: { DataBeanProperties: row }
        });
        onChange(row.IDTaxHold);
        modalTable.close();
    };

    const getLista = () => {
        TaxHold.instance.getTaxHoldCatalog().then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    const getTaxHoldLabel = (item: any) => {
        return [item?.Mnemonic, item?.Description].filter(Boolean).join(' - ');
    }

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDTaxHold,
        label: getTaxHoldLabel(item.DataBeanProperties),
        item: item
    }));

     const head = [                
        { title: 'ID', property: 'IDTaxHold',visible:false,mask:MASK_NUMBER },
        { title: 'Mnemonic', property: 'Mnemonic' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Cell', property: 'Cell' },
        
    ]

    return (
        <>
            <label>{label ?? "Proceso"}</label>
            {renderType === 'ID' ?
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Seleccione ..."
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
            :
            <>
            <div className="row">
                <div className="col-md-12">
                    
                    <input type="text" className='form-control' value={getTaxHoldLabel(bean)} readOnly onClick={()=>{modalTable.open()}} />
                </div>
                <div className="col-md-12">
                    <Modal modal={modalTable.modal} updateModal={modalTable.setModal}>
                        <BasicTable body={lista} head={head} rowSet={handleRowSelect}></BasicTable>
                    </Modal>

                </div>
            </div>

            </>
            }
        </>
    )
}
